import spacing from '../spacing';

/**
 * The configs for our chegg breakpoints
 * 320px is our actual minimum supported size (aka that’s what we design for)
 * but for sizes below that (which only exist when forced by people resizing their screens)
 * we also want components to use the small breakpoint
 */
var breakPointConfig = {
  sm: {
    cols: 4,
    // the number of columns in the grid
    gap: '1rem',
    // css grid gap setting
    min: '0px',
    // media query values
    max: '599px',
    marginLeftRight: spacing.px16
  },
  md: {
    cols: 8,
    gap: '1.5rem',
    min: '600px',
    max: '899px',
    marginLeftRight: spacing.px24
  },
  lg: {
    cols: 12,
    gap: '1.5rem',
    min: '900px',
    max: '1199px',
    marginLeftRight: spacing.px24
  },
  xl: {
    cols: 12,
    gap: '1.5rem',
    min: '1200px',
    max: '2000000px',
    marginLeftRight: spacing.px24
  }
};
export default breakPointConfig;